module.exports = __webpack_public_path__ + "img/00009.3210f37a.webp";